import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';
import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

import get from 'lodash-es/get';
import map from 'lodash-es/map';

interface FeedItemEvent {
  featured_accounts: Account[];
  group: Group;
  opportunity: Opportunity;
  url: string;
}

@Pipe({
  name: 'appToFeedItemEvent',
})
export class ToFeedItemEventPipe implements PipeTransform {
  transform(event: any): FeedItemEvent {
    return {
      featured_accounts: map(
        get(event, 'featured_accounts', []),
        (account: Account) => {
          return {
            ...account,
            job_title: get(account, 'experience[0].job_title', ''),
            organization_name: get(
              account,
              'experience[0].organization_name',
              '',
            ),
            url: `/profile/${get(account, 'slug')}`,
          };
        },
      ),
      group: event.owner_group,
      opportunity: {
        ...event,
        location: get(event.event_location, 'custom_label', ''),
      },
      url: `/hub/${get(event, 'owner_group.slug', '')}/opportunity/${get(
        event,
        'slug',
        '',
      )}`,
    };
  }
}
